import Header from "../components/Header";
import Footer from "../components/Footer";

const SECTIONS = [
  {
    h: "1. Agreement",
    p: [
      "These Terms of Service (\"Terms\") form a binding agreement between you (\"Customer\", \"you\") and oly Inbox, a product operated by oly Payroll (\"oly Inbox\", \"we\", \"us\"). By creating an account or using the Service you agree to these Terms and to our Privacy Policy.",
    ],
  },
  {
    h: "2. The Service",
    p: [
      "oly Inbox provides inbound email forwarding (\"Service\") that receives mail sent to addresses on a custom domain you control and forwards it to a destination mailbox you specify (Gmail, Outlook, iCloud, etc.). The Service is delivered using Mailgun as our sending and routing infrastructure provider.",
      "We do not provide a mailbox, storage of incoming mail, or inbox UI. Mail is forwarded and not retained on our systems beyond what is required for delivery.",
    ],
  },
  {
    h: "3. Account & eligibility",
    p: [
      "You must be 18+ and provide accurate account information. You are responsible for all activity under your account and for safeguarding your password. Notify us immediately of any unauthorized use.",
      "One individual or organization per account. You may not resell the Service without written permission.",
    ],
  },
  {
    h: "4. Fees, billing, and renewals",
    p: [
      "Paid plans are billed monthly or annually in advance via Stripe. Each domain you add is a separate line item billed at its chosen tier (Starter $3/mo, Growth $6/mo, or Pro $9/mo per domain). Subscriptions renew automatically until cancelled.",
      "We will charge your payment method at the beginning of each billing period. If a charge fails, we may suspend the Service until the balance is paid.",
      "Refunds: unused annual prepayments are prorated on cancellation per our standard policy. Monthly plans are not refunded for partial months.",
    ],
  },
  {
    h: "5. Acceptable use",
    p: [
      "You may not use the Service to send or route (a) unsolicited bulk email or spam, (b) phishing, malware, or fraudulent content, (c) content that infringes intellectual property rights, violates the CAN-SPAM Act, GDPR, or any applicable law. You must own or have authorization to use each domain you connect.",
      "We may suspend or terminate accounts that violate this section. Repeated or severe abuse (spam, spoofing, bulk fraudulent mail) will result in immediate termination with no refund.",
    ],
  },
  {
    h: "6. Deliverability",
    p: [
      "Email deliverability depends on many factors outside our control, including DNS propagation, recipient mailbox policies, and your domain reputation. We provide best-effort routing and real-time deliverability diagnostics, but we do not guarantee delivery of any individual message.",
    ],
  },
  {
    h: "7. Data & privacy",
    p: [
      "We process only the data needed to route your email (envelope metadata, temporary message transfer). Message bodies pass through Mailgun infrastructure and are not stored by oly Inbox. Full details are in our Privacy Policy.",
    ],
  },
  {
    h: "8. Termination",
    p: [
      "You may cancel any plan at any time from your Stripe customer portal. On cancellation we stop processing mail at the end of your current billing period and remove your Mailgun routes within 30 days.",
      "We may terminate your account with notice for material breach of these Terms or with immediate effect for abuse of the Service.",
    ],
  },
  {
    h: "9. Warranty disclaimer",
    p: [
      "THE SERVICE IS PROVIDED \"AS IS\" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.",
    ],
  },
  {
    h: "10. Limitation of liability",
    p: [
      "TO THE MAXIMUM EXTENT PERMITTED BY LAW, OLY INBOX SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, OR FOR LOSS OF PROFITS, REVENUE, DATA, OR GOODWILL, ARISING FROM YOUR USE OF THE SERVICE. OUR AGGREGATE LIABILITY FOR ANY CLAIM IS LIMITED TO THE AMOUNT YOU PAID US IN THE 12 MONTHS PRECEDING THE CLAIM.",
    ],
  },
  {
    h: "11. Changes to these Terms",
    p: [
      "We may update these Terms from time to time. Material changes will be emailed to the address on file at least 14 days before taking effect. Continued use of the Service after the effective date constitutes acceptance.",
    ],
  },
  {
    h: "12. Governing law",
    p: [
      "These Terms are governed by the laws of the State of Delaware, USA, without regard to conflict-of-laws principles. Any dispute will be resolved in the state or federal courts located in Delaware.",
    ],
  },
  {
    h: "13. Contact",
    p: [
      "Questions? Email support@olyinbox.com.",
    ],
  },
];

export default function Terms() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-3xl mx-auto px-6 lg:px-8 py-16" data-testid="terms-page">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#F26953] mb-3">Legal</div>
        <h1 className="text-4xl sm:text-5xl font-bold text-[#0F172A] tracking-tight">Terms of Service</h1>
        <p className="text-sm text-[#475569] mt-3">Last updated: April 22, 2026</p>

        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.h}>
              <h2 className="text-lg font-bold text-[#0F172A]">{s.h}</h2>
              {s.p.map((para, i) => (
                <p key={i} className="mt-3 text-sm leading-relaxed text-[#475569]">{para}</p>
              ))}
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
